import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import {FormControlLabel,FormGroup,Grid,Slider,Switch,Typography,Checkbox} from "@mui/material";
import Heatmap from "./Heatmap";
import StartIconButton from "../../components/buttons/StartIconButton";
import SaveIcon from "@mui/icons-material/Save";
import Box from "@mui/material/Box";
import TextInput from "../../components/forms/TextInput";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import useGetSessionType from "../../constants/sessionType";

const useStyles = makeStyles(theme => ({
    slider: {
        padding: theme.spacing(1)
    },
    sliderText: {
        paddingRight: "0.8rem",
    },
    select: {
        width: "12rem"
    },
    secondColumn: {
        paddingTop: "0.33rem"
    }
}));

export default function HeatmapContainer() {
    //todo: filtri e dati di default per open data
    const { t } = useTranslation();
    let classes = useStyles();
    const yesterday = dayjs(new Date(new Date().setDate(new Date().getDate() - 1))).format("YYYY-MM-DD");
    const today = dayjs(new Date()).format("YYYY-MM-DD");
    let [filters, setFilters] = useState({
        isHomeWorkPath: null,
        minAge: 14,
        maxAge: 65,
        type: -1,
        minTime: "00:00",
        maxTime: "23:59",
        minDate: dayjs(new Date().setMonth(new Date().getMonth() - 1)).format("YYYY-MM-DD"),
        maxDate: yesterday
    });
    let sessionType = useGetSessionType();
    sessionType = sessionType.filter(st => st.id === 0 || st.id === 1);
    sessionType.unshift({ id: -1, name: t('all') })

    let [isShowingOrganizationArea, setIsShowingOrganizationArea] = useState(true)
    let [savedFilters, setSavedFilters] = useState({ ...filters })
    let [showMarkers, setShowMarkers] = useState({startStop: false, pauseResume: false});

    return (
        <Grid container>
            <Grid container direction="row">
                <Grid item md={10} xs={12}>
                    <Grid container alignItems={"center"} justifyContent={"space-evenly"}>
                        <Grid xs={12} md={4} container justifyContent={"center"}>
                            <FormControlLabel
                                control={
                                    <Switch checked={filters.isHomeWorkPath} color="primary"
                                        onChange={evt => setFilters({
                                            ...filters,
                                            isHomeWorkPath: evt.target.checked? true : null
                                        })} />
                                }
                                label={t('onlyHomeWorkPath')}
                            />
                        </Grid>

                        <Grid xs={12} md={4} container justifyContent={"center"} className={classes.slider}>
                            <Grid container justifyContent={"center"} alignItems={"center"} direction={"row"}>
                                <Grid item>
                                    <Typography gutterBottom className={classes.sliderText}>{t('age')}</Typography>
                                </Grid>
                                <Grid>
                                    <Box sx={{ width: 300 }}>
                                        <Slider
                                            value={[filters.minAge, filters.maxAge]}
                                            onChange={(event, newValues) => setFilters({
                                                ...filters,
                                                minAge: newValues[0],
                                                maxAge: newValues[1]
                                            })}
                                            valueLabelDisplay="auto" max={110}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} md={4} container justifyContent={"center"}>
                            <TextInput label={t('bikeType')} value={filters.type} options={sessionType}
                                select className={classes.select} color={"dark"}
                                onTextChange={(value) => setFilters({ ...filters, type: value })}>
                                {sessionType.map(o => <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>)}
                            </TextInput>
                        </Grid>
                        <Grid container xs={12} md={6} direction="row" spacing={4}
                            style={{ margin: 0, width: "100%", marginBottom: "0.5rem" }}>
                            <Grid item xs={6}>
                                <TextInput required label={t('startPeriod')} value={filters.minDate} type="date"
                                    color="dark" max={today}
                                    onTextChange={value => {
                                        if (filters.maxDate < value.trim()) setFilters({
                                            ...filters,
                                            maxDate: value.trim(),
                                            minDate: value.trim()
                                        })
                                        else setFilters({ ...filters, minDate: value.trim() })
                                    }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextInput required label={t('endPeriod')} value={filters.maxDate} type="date"
                                    color="dark" max={today}
                                    onTextChange={value => {
                                        if (value.trim() < filters.minDate) setFilters({
                                            ...filters,
                                            minDate: value.trim(),
                                            maxDate: value.trim()
                                        })
                                        else setFilters({ ...filters, maxDate: value.trim() })
                                    }} />
                            </Grid>
                        </Grid>
                        <Grid container xs={12} md={6} direction="row" spacing={4}
                            style={{ margin: 0, width: "100%", marginBottom: "0.5rem" }}>
                            <Grid item xs={6}>
                                <TextInput required label={t('timeSlotStart')} value={filters.minTime}
                                    type="time" color="dark"
                                    onTextChange={value => {
                                        if (filters.maxTime < value.trim()) setFilters({
                                            ...filters,
                                            maxTime: value.trim(),
                                            minTime: value.trim()
                                        })
                                        else setFilters({ ...filters, minTime: value.trim() })
                                    }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextInput required label={t('timeSlotEnd')} value={filters.maxTime} type="time"
                                    color="dark"
                                    onTextChange={value => {
                                        if (value.trim() < filters.minTime) setFilters({
                                            ...filters,
                                            minTime: value.trim(),
                                            maxTime: value.trim()
                                        })
                                        else setFilters({ ...filters, maxTime: value.trim() })
                                    }} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container md={2} xs={12} alignItems={"center"} justifyContent={"center"}
                    style={{ margin: 0, width: "100%", marginBottom: "1.5rem" }}>
                    <Grid item>
                        <StartIconButton onClick={() => setSavedFilters({ ...filters })} title={t('save')}
                            startIcon={<SaveIcon />}
                            disabled={JSON.stringify(filters) === JSON.stringify(savedFilters)} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container justifyContent="space-between" xs={12}>
                <Grid item
                    sx={{
                        width: '25%',
                        minWidth: t('hideInitiativeArea').length + 'ex'
                    }}
                >
                    <StartIconButton
                        title={isShowingOrganizationArea ? t('hideInitiativeArea') : t('showInitiativeArea')}
                        onClick={() => setIsShowingOrganizationArea(prevState => !prevState)}
                        startIcon={isShowingOrganizationArea ? <VisibilityOff /> : <Visibility />} />
                </Grid>

                <Grid container
                      sx={{width: '25%'}}
                      justifyContent={"right"}
                >
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showMarkers.startStop} name="startStop"
                                    onChange={event => {
                                        setShowMarkers({...showMarkers, startStop: event.target.checked})
                                    }}
                                />
                            }
                            label={t('startStopPartials')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showMarkers.pauseResume} name="pauseResume"
                                    onChange={event => {
                                        setShowMarkers({...showMarkers, pauseResume: event.target.checked})
                                    }}
                                />
                            }
                            label={t('pauseResumePartials')}
                        />
                    </FormGroup>
                </Grid>

            </Grid>
            <Heatmap filters={savedFilters} showOrganizationArea={isShowingOrganizationArea} showMarkers={showMarkers} >

            </Heatmap>
        </Grid>
    );
}

